// do this when loading everything
// so after loading all (non lazyloaded) images

// imports --------------------------------------------------------------------
import * as Listeners from './1-listeners.js';
import * as Resize from "./4-resize.js";
import * as Scroll from "./5-scroll.js";

// exported variables ---------------------------------------------------------

// local variables ------------------------------------------------------------

// page loaded function -------------------------------------------------------
export const loadedPage = () => {
  // sets all the pages after loading
  // console.log('loadedPage');

  // into frame so it's not called before onready (which Firefox and Safari do)
  requestAnimationFrame(() => {
    // because things might've changed after font/img loading
    Resize.setResize(true);

    // scroll to hash?
    const hash = window.location.hash.substring(1);
    const el = document.getElementById(hash);

    if (hash && el) {
      Scroll.scrollToEl(el);
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const nr = urlParams.get('nr');
      
      if (nr !== '' && nr !== null) {
        Listeners.scrollToAnchor(nr);
      } else {
        const title = urlParams.get('title');

        if (title !== '' && title !== null) {
          const infoBtnEl = document.querySelector(`.info__button[data-title="${title}"]`);
          // console.log({ title, encodedTitle, infoBtnEl });
          if (infoBtnEl) {
            infoBtnEl.click();
            Scroll.scrollToEl(infoBtnEl);
          }
        }
      }
    }
  });
};

